export enum RequestVersionUpdateTarget {
	Tab = "tab",
	ActionsLog = "actions-log",
}
